import {
    AbstractViewContribution,
    FrontendApplication,
    FrontendApplicationContribution
} from '@theia/core/lib/browser';
import { injectable } from '@theia/core/shared/inversify';
import { DesignPanel } from './design-panel';

/**
 * Registers the DesignPanel and opens it in the left sidebar.
 *
 * The panel is intentionally not registered in any menu because it should only
 * be accessible from design mode (the sidebar tab is hidden in code mode via
 * CSS).
 */
@injectable()
export class DesignPanelContribution
    extends AbstractViewContribution<DesignPanel>
    implements FrontendApplicationContribution
{
    constructor() {
        super({
            widgetId: DesignPanel.ID,
            widgetName: DesignPanel.LABEL,
            defaultWidgetOptions: { area: 'left' }
        });
    }

    async onDidInitializeLayout(_app: FrontendApplication): Promise<void> {
        // Add the panel to the left sidebar without activating it.
        // LayoutModeContribution will activate it when design mode is entered.
        await this.openView({ activate: false, reveal: false });
    }
}
